import {
  GET_USER_INFO_FAILED,
  GET_USER_INFO_REQUEST,
  GET_USER_INFO_REQUEST_SUCCEEDED,
  NEW_PASSWORD_REQUEST,
  NEW_PASSWORD_REQUEST_FAILED,
  NEW_PASSWORD_REQUEST_SUCCEEDED,
  SET_USER_INFO,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_REQUEST_FAILED,
  UPDATE_PASSWORD_REQUEST_SUCCEEDED,
  UPDATE_USER_INFO_FAILED,
  UPDATE_USER_INFO_REQUEST,
  UPDATE_USER_INFO_REQUEST_SUCCEEDED,
  USER_FORGOT_PASSWORD_REQUEST,
  USER_FORGOT_PASSWORD_REQUEST_FAILED,
  USER_FORGOT_PASSWORD_REQUEST_SUCCEEDED
} from "../constants/user";

export const user = (state = { data: [], isFetching: false, error: {}, userInfo: null }, action) => {
  let newState = { ...state };
  switch (action.type) {
    case USER_FORGOT_PASSWORD_REQUEST:
    case GET_USER_INFO_REQUEST:
    case UPDATE_USER_INFO_REQUEST:
      newState.isFetching = true;
      return newState;

    case USER_FORGOT_PASSWORD_REQUEST_SUCCEEDED:
    case GET_USER_INFO_REQUEST_SUCCEEDED:
    case UPDATE_USER_INFO_REQUEST_SUCCEEDED:
      newState.data = action.data;
      newState.isFetching = false;
      newState.error = {};
      return newState;

    case USER_FORGOT_PASSWORD_REQUEST_FAILED:
    case GET_USER_INFO_FAILED:
    case UPDATE_USER_INFO_FAILED:
      newState.error = action.error;
      newState.isFetching = false;
      newState.data = [];
      return newState;

    case SET_USER_INFO:
      newState.userInfo = action.payload;
      return newState;

    default:
      return state;
  }
};

export const newPassword = (state = { data: [], isFetching: false, error: {} }, action) => {
  let newState = { ...state };
  switch (action.type) {
    case NEW_PASSWORD_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
      newState.isFetching = true;
      return newState;

    case NEW_PASSWORD_REQUEST_SUCCEEDED:
    case UPDATE_PASSWORD_REQUEST_SUCCEEDED:
      newState.data = action.data;
      newState.isFetching = false;
      newState.error = {};
      return newState;

    case NEW_PASSWORD_REQUEST_FAILED:
    case UPDATE_PASSWORD_REQUEST_FAILED:
      newState.error = action.error;
      newState.isFetching = false;
      newState.data = [];
      return newState;

    default:
      return newState;
  }
};
